import React, { useEffect, useImperativeHandle, useState, forwardRef } from "react";
import "./SearchBar.css";
import useDebounce from "../../../hooks/useDebounce";

type TProps = {
  placeholder?: string;
  onTextChange?: (searchText: string) => void;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  userSearchingStatus?: (status: boolean) => void;
}

export type SearchBarHandle = {
  clearInput: () => void; // Define the type of the exposed method
};

const SearchBar = forwardRef<SearchBarHandle, TProps>((props, ref) => {
  const { placeholder, onTextChange, onFocus, userSearchingStatus } = props;

  const [searchText, setSearchText] = useState<string>("");
  const debounceSearchText = useDebounce(searchText, 1000);
  const [isUserSearching, setIsUserSearching] = useState<boolean>(false); 

  useImperativeHandle(ref, () => ({
    clearInput: () => {
      setSearchText(""); 
      if(userSearchingStatus) 
        userSearchingStatus(false);
    },
  }));

  useEffect(() => {
    if(onTextChange) {
      onTextChange(debounceSearchText);
    }
  }, [debounceSearchText]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
    if(e.target.value?.length){
      if(!isUserSearching){
        if(userSearchingStatus)
          userSearchingStatus(true);
        setIsUserSearching(true);
      }
    }else {
      if(isUserSearching){
        if(userSearchingStatus)
          userSearchingStatus(false);
        setIsUserSearching(false);
      }
    }
  };

  return (
    <div id="searchBarContainer">
      <input
        type="search"
        name="plotSearchBox"
        id="plotSearchBox"
        value={searchText}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder ?? "Search"}
      />
    </div>
  );
});

SearchBar.displayName = "SearchBar";
export default SearchBar;